import { StorageService } from '@empathy/storage-service';
import { container } from '../../../container';
import { DEPENDENCIES, STORAGE } from '../../../container/dependencies.const';
import { HISTORY_ACTIONS_KEYS, HISTORY_MUTATIONS_KEYS } from '../history.const';
import { HistoryAction, HistoryContext } from '../history.interfaces';

export class SetEnabledQueryHistoryAction implements HistoryAction {
  actions = {
    [HISTORY_ACTIONS_KEYS.setEnabledQueryHistory]: ({ commit, state, dispatch }: HistoryContext, enabled: boolean): any => {
      const storageService = container.getNamed<StorageService>(DEPENDENCIES.StorageService, STORAGE.Local);
      commit(HISTORY_MUTATIONS_KEYS.setEnabledQueryHistory, enabled);
      storageService.setItem('enabled_history', enabled);
      if (!enabled) {
        return dispatch(HISTORY_ACTIONS_KEYS.clearQueryHistory);
      }
    }
  };
}
